import React from 'react'
import FAQs from '../../components/FAQs'
import MainHeader from '../../components/MainHeader'
import Programs from '../../components/Programs'
import Testimonial from '../../components/Testimonial'
import Values from '../../components/Values'
import './home.css'


const Home = () => {
  return (
    <div>
       <MainHeader />
       <Programs />
       <Values />
       <FAQs />
       <Testimonial />
    </div>
  )
}

export default Home